import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';
import { ObfuscatedEmail } from '@/components/legal/ObfuscatedEmail';
import { makeMetaTitle } from '@/modules/META';

export const Route = createFileRoute('/_content/kontakt')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  head: () => ({
    meta: [makeMetaTitle(['Kontakt'])],
  }),
});

function RouteComponent() {
  return (
    <Fragment>
      <LegalHeading level="h1" sx={{ marginTop: 0 }}>
        Kontakt
      </LegalHeading>
      <LegalText>
        Der RadMELDER Baden-Württemberg befindet sich in einer Pilotphase. Das bedeutet, dass manchmal Fehler auftreten
        könnten oder nicht das gewünschte Ergebnis dargestellt wird. Die Datengrundlage für die automatische
        Meldungszuordnung laut Radnetz-Zuständigkeit wird sich in den kommenden Monaten laufend verbessern. Der
        RadMELDER Baden-Württemberg wird derzeit um weitere Funktionen erweitert. Sie können die Anwendung jedoch
        bereits jetzt gerne nutzen.
      </LegalText>
      <LegalText>
        Bei Fragen oder Hinweisen wenden Sie sich gerne an <ObfuscatedEmail name="radmelder" />
      </LegalText>
    </Fragment>
  );
}
